import { SET_PAGE } from "./actiontype";

export const set_page = (payload) => ({
  type: SET_PAGE,
  payload,
});
